import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { formatCurrency } from '../../../../utils/formatters';
import DateSelectRange from '../../../elements/DateSelectRange';
import Search from '../../../elements/Search';
import Paginator from '../../../elements/paginator';
import axios from '../../../services/MyAxios';

function ReportGGRPerGameCreator() {
    const [report, setReport] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');

    const [range, setRange] = useState('this-month');
    const [startDate, setStartDate] = useState(moment().startOf('month'));
    const [endDate, setEndDate] = useState(moment().endOf('month'));

    const getReport = (page = 1) => {
        if (filter.length !== 0 && filter.length < 3) {
            return;
        }

        const formattedStartDate = startDate?.isValid() ? startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss') : null;
        const formattedEndDate = endDate?.isValid() ? endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss') : null;

        let url = '/crea/casino/api/reports/ggr/game-creator';
        if (page !== 1) {
            url += `?page=${page}`;
        }

        axios
            .get(url, {
                params: {
                    filter,
                    start: formattedStartDate,
                    end: formattedEndDate,
                },
            })
            .then((response) => {
                setReport(response.data.data);
                setCurrentPage(response.data.current_page);
                setLastPage(response.data.last_page);
            });
    };

    useEffect(() => {
        getReport(currentPage);
    }, []);

    useEffect(() => {
        getReport(currentPage);
    }, [filter, startDate, endDate]);

    const handleFilterTable = (value) => {
        setFilter(value);
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex justify-content-between">
                    <Search filterTable={handleFilterTable} />
                    <DateSelectRange
                        range={range}
                        setRange={setRange}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </div>
                <div className="search-info">Min. 3 chars to search</div>
                {report.length > 0 ? (
                    <div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Game creator</th>
                                    <th>Sum of bets</th>
                                    <th>Sum of wins</th>
                                    <th>GGR</th>
                                </tr>
                            </thead>
                            <tbody>
                                {report.map((reportData) => (
                                    <tr key={reportData.creator_name}>
                                        <td>{reportData.creator_name}</td>
                                        <td>{formatCurrency(reportData.sum_of_bets, 2)}</td>
                                        <td>{formatCurrency(reportData.sum_of_wins, 2)}</td>
                                        <td>{formatCurrency(reportData.ggr, 2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getReport} />
                    </div>
                ) : (
                    <p>Cannot find any transaction to create report.</p>
                )}
            </div>
        </div>
    );
}

export default ReportGGRPerGameCreator;
